import { render, staticRenderFns } from "./VoiceActionControl.vue?vue&type=template&id=21cc786a&"
import script from "./VoiceActionControl.vue?vue&type=script&lang=js&"
export * from "./VoiceActionControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports